import { render } from "./bet.vue?vue&type=template&id=d39e83f2&scoped=true"
import script from "./bet.vue?vue&type=script&lang=js"
export * from "./bet.vue?vue&type=script&lang=js"

import "./bet.vue?vue&type=style&index=0&id=d39e83f2&lang=scss&scoped=true"

import exportComponent from "E:\\My Websites\\v12\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d39e83f2"]])

export default __exports__